export default __webpack_public_path__ + "static/media/certificate2Large.5c8feb4b.webp";